angular.module('gym.calendar').controller('BulkBookingsCtrl', ["$scope", "$rootScope", "$stateParams", "$modalInstance", "$modal", "$http", "$filter", "EventService", "flash", "event", "contact", "bookings", function($scope, $rootScope, $stateParams, $modalInstance, $modal, $http, $filter, EventService, flash, event, contact, bookings) {
  var checkContactRecurringBookings, enableRecurringBooking, eventIsInThePast, getBookAllLimits, gym, prospectBookingLimit, ref;
  $scope.numberOfEvents = (function() {
    var results = [];
    for (var i = 1, ref = event.future_events_count; 1 <= ref ? i <= ref : i >= ref; 1 <= ref ? i++ : i--){ results.push(i); }
    return results;
  }).apply(this);
  $scope.currentUser = window.currentUser;
  $scope.event = event;
  $scope.contact = contact;
  $scope.gym = gym = $rootScope.gym;
  $scope.gymNow = moment().tz(gym.tz).format('MMM D, YYYY h:mma');
  $scope.recurringBookingsEnabled = gym.gym_config.recurring_bookings_feature_enabled && event.event_schedule_id && event.future_events_count > 1;
  prospectBookingLimit = $scope.gym.gym_booking_detail.prospect_booking_limit;
  $scope.displayProspectBookingLimit = contact.type === 'prospect' && prospectBookingLimit !== null && contact.non_absent_booking_count >= prospectBookingLimit;
  eventIsInThePast = function() {
    return moment($scope.gymNow, 'MMM D, YYYY h:mma').isAfter(moment($scope.event.start_at, 'YYYY/MM/DD HH:mm'));
  };
  $scope.bookFromPolicyOptions = eventIsInThePast() ? [['book_from_now', 'Now']] : [['book_from_current_event', 'This event'], ['book_from_now', 'Now']];
  checkContactRecurringBookings = function() {
    var params;
    if (!$scope.recurringBookingsEnabled) {
      return;
    }
    params = {
      event_schedule_id: $scope.event.event_schedule_id,
      contact_id: contact.id
    };
    return EventService.getRecurringBookings(params).then(function(recurringBookings) {
      return $scope.alreadyEnabledForContact = !!recurringBookings.length;
    });
  };
  checkContactRecurringBookings();
  $scope.recurringBookingParams = {
    contact_id: contact.id,
    book_from_policy: $scope.bookFromPolicyOptions[0][0]
  };
  getBookAllLimits = function() {
    var url;
    url = `gyms/${gym.id}/calendar/events/${event.id}/book_all_limits`;
    return $http.get(url, {
      params: {
        contact_id: contact.id
      }
    }).then(function(response) {
      return $scope.bookAllLimits = response.data;
    });
  };
  getBookAllLimits();
  $scope.eventFullButHasAbsentBookingsMessageVisible = function() {
    return bookings.length >= $scope.event.participant_limit && $scope.event.non_absent_bookings_count < $scope.event.participant_limit;
  };
  $scope.enabledMakeupClass = function() {
    var ref1;
    $scope.booking.add_makeup_class = true;
    $scope.booking.free_class = false;
    if (!$scope.booking.makeup_class_membership_id) {
      return $scope.booking.makeup_class_membership_id = (ref1 = contact.memberships_for_makeup_classes[0]) != null ? ref1.id : void 0;
    }
  };
  $scope.toggleFreeClass = function(value) {
    $scope.booking.free_class = value;
    $scope.booking.add_makeup_class = false;
    $scope.booking.makeup_class_membership_id = void 0;
    return $scope.booking.makeup_class_reason = void 0;
  };
  $scope.makeupClassOptionVisible = function() {
    return ($scope.contact.show_makeup_class_option || $scope.showMakeupClassOption) && $scope.booking.type === 'one';
  };
  $scope.onBookingTypeChange = function() {
    if ($scope.booking.add_makeup_class && $scope.booking.type !== 'one') {
      return $scope.toggleFreeClass(false);
    }
  };
  $scope.booking = {
    type: 'one',
    count: 1,
    free_class: false
  };
  $scope.freeClassOptionAvailable = contact.type === 'member' && !event.free_class;
  $scope.isLastEvent = function() {
    return $scope.event.future_events_count === 1;
  };
  $scope.hasMembershipForRecurringBooking = function() {
    return $scope.event.free_class || $scope.booking.free_class || contact.recurring_booking_eligible_memberships_exist;
  };
  enableRecurringBooking = function() {
    return EventService.enableRecurringBooking($scope.booking, $scope.recurringBookingParams, event.id).then(function() {
      return $modalInstance.close();
    }, function(data) {
      var ref1, ref2;
      $scope.isLoading = false;
      if ((ref1 = data.errors) != null ? ref1.message : void 0) {
        return $scope.recurringBookingError = (ref2 = data.errors) != null ? ref2.message : void 0;
      }
    });
  };
  $scope.save = function() {
    var params, url;
    $scope.isLoading = true;
    if ($scope.booking.type === 'recurring') {
      enableRecurringBooking();
      return;
    }
    if ($scope.booking.add_makeup_class) {
      params = {
        position: bookings.length + 1,
        student: contact,
        add_makeup_class: $scope.booking.add_makeup_class,
        makeup_class_membership_id: $scope.booking.makeup_class_membership_id,
        makeup_class_reason: $scope.booking.makeup_class_reason
      };
      url = `/gyms/${$scope.gym.id}/calendar/events/${event.id}/bookings`;
      return $http.post(url, {
        booking: params
      }).then(function(response) {
        flash.success = `Booking for ${response.data.student.name} added successfully`;
        return $modalInstance.close(response.data);
      });
    } else {
      url = `gyms/${gym.id}/calendar/events/${event.id}/bulk_bookings/book_${$scope.booking.type}`;
      params = {
        student_id: contact.id,
        event_id: event.id,
        number_of_events: $scope.booking.count,
        free_class: $scope.booking.free_class
      };
      return $http.post(url, params).then(function(response) {
        var lastBookingDate;
        $scope.isLoading = false;
        bookings = response.data.bookings.valid;
        if (bookings.length) {
          lastBookingDate = $filter('date')(_.last(bookings).start_at);
          flash.success = `${bookings.length} events booked successfully. Last booking: ${lastBookingDate}.`;
        } else {
          flash.success = response.data.message;
        }
        return $modalInstance.close(response.data);
      }, function(response) {
        var eventIsFull, hasSuspension, ref1;
        $scope.isLoading = false;
        $scope.failedBookings = response.data;
        eventIsFull = ((ref1 = $scope.failedBookings.bookings.invalid[0]) != null ? ref1.validation_error : void 0) === 'Event full';
        hasSuspension = _.any($scope.failedBookings.bookings.invalid, function(b) {
          return /suspension/i.test(b.validation_error);
        });
        if ($scope.booking.type === 'one' && contact.memberships_for_makeup_classes.length && !eventIsFull && !hasSuspension) {
          $scope.showMakeupClassOption = true;
          if (!$scope.booking.makeup_class_membership_id) {
            return $scope.booking.makeup_class_membership_id = contact.memberships_for_makeup_classes[0].id;
          }
        }
      });
    }
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
